import { render } from "./MobileBanner.vue?vue&type=template&id=7348226e&scoped=true"
import script from "./MobileBanner.vue?vue&type=script&lang=js"
export * from "./MobileBanner.vue?vue&type=script&lang=js"

import "./MobileBanner.vue?vue&type=style&index=0&id=7348226e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7348226e"]])

export default __exports__